import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import './MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { DocumentIcon, PlusIcon, SearchIcon, UploadIcon } from '../common/mdPageIcons';

export class MDAlumnos extends Component {
  static displayName = MDAlumnos.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
      exporting: false,
    };
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleExportPagoInscripcion = this.handleExportPagoInscripcion.bind(this);
    this.searchInputRef = React.createRef();
  }

  handleRemoveItem = (alumno) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: alumno.alumnoCodigo,
        dni: alumno.alumnoDni,
        nombre: alumno.alumnoNombre,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWAlumnos');
    if (canAccess) {
      this.populateData();
    }
  }

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  handleExportPagoInscripcion = () => {
    if (isMdMutationLocked(this) || this.state.exporting) return;
    this.exportPagoInscripcion();
  };

  renderAlumnosTable(alumnos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="md-alumnos-title">
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text">DNI</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Nombre y Apellido</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Pago Inscripción</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.alumnoCodigo}>
                <MdTableCell cellType="text">{alumno.alumnoDni}</MdTableCell>
                <MdTableCell cellType="text">{alumno.alumnoNombre}</MdTableCell>
                <MdTableCell cellType="text">
                  {alumno.alumnoPagoInscripcion ? 'Sí' : 'No'}
                </MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions
                    items={buildStandardRowActions({
                      editTo: '/update-alumno/' + alumno.alumnoCodigo + '/0',
                      onDelete: () => this.handleRemoveItem(alumno),
                      deleteDisabled: this.state.loading || this.state.deletingId === alumno.alumnoCodigo,
                      deleteLabel: this.state.deletingId === alumno.alumnoCodigo ? 'Eliminando...' : 'Borrar',
                      detailTo: '/update-alumno/' + alumno.alumnoCodigo + '/1',
                    })}
                  />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching || this.state.exporting;
    const listLoading = this.state.loading && !this.state.deletingId && !this.state.exporting;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderAlumnosTable(this.state.paginationData);

    return (
      <div className="md-page md-alumnos">
        <h1 id="md-alumnos-title" className="md-page__title">Manejar Datos de Alumnos</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <>
            <div className="md-page__toolbar">
              <Link className="md-page__action-link" to="/add-alumno">
                <PlusIcon />
                Nuevo Alumno
              </Link>
              <Link className="md-page__action-link" to="/iap">
                <UploadIcon />
                Inscripción masiva
              </Link>
              <Link className="md-page__action-link" to="/pago-inscripcion">
                <UploadIcon />
                Marcar pago inscripción
              </Link>
              <button
                type="button"
                className="md-page__action-link"
                onClick={this.handleExportPagoInscripcion}
                disabled={isBusy}
              >
                <DocumentIcon />
                {this.state.exporting ? 'Exportando...' : 'Exportar alumnos activos'}
              </button>
            </div>

            <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
              <div className="md-page__search-wrap">
                <span className="md-page__search-icon">
                  <SearchIcon />
                </span>
                <input
                  ref={this.searchInputRef}
                  className="md-page__search-input"
                  type="text"
                  name="search"
                  autoComplete="off"
                  disabled={isBusy}
                  placeholder="Ingrese DNI o Apellido del alumno"
                  value={this.state.searchInput}
                  onChange={this.handleSearchInputChange}
                />
              </div>
              <button
                type="submit"
                className="md-page__search-btn"
                disabled={isBusy}
              >
                Buscar
              </button>
            </form>

            {contents}

            {!listLoading && this.state.pageCount > 0 ? (
              <div className="md-page__pagination">
                <ReactPaginate
                  previousLabel="Anterior"
                  nextLabel="Siguiente"
                  breakLabel="..."
                  breakClassName="break-me"
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  forcePage={Math.floor(this.state.offset / this.state.perPage)}
                  onPageChange={this.handlePageClick}
                  containerClassName="pagination"
                  subContainerClassName="pages pagination"
                  activeClassName="active"
                />
              </div>
            ) : null}
        </>

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar alumno"
          message="Esta acción eliminará al alumno del sistema y no se puede deshacer."
          detail={
            pendingDelete
              ? `${pendingDelete.nombre} — DNI ${pendingDelete.dni}`
              : ''
          }
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/Students/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/Students/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data) || data.returnModel === false) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar el alumno. Verifique si tiene registros asociados e intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({ successMessage: 'El alumno se eliminó correctamente.', pendingDelete: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }

  async exportPagoInscripcion() {
    this.clearFeedback();
    this.setState({ exporting: true });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/Students/export-pago-inscripcion', {
        method: 'GET',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data) || !data.returnModel) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo generar el Excel de alumnos con pago de inscripción.'
          ),
        });
        return;
      }

      try {
        const byteCharacters = atob(data.returnModel);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'alumnos-activos-pago-inscripcion.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
        this.setState({
          successMessage: 'Se descargó el Excel de alumnos activos con pago de inscripción.',
        });
      } catch {
        this.setState({
          showErrorMessage: true,
          errorMessage: 'No se pudo descargar el archivo Excel generado.',
        });
      }
    });
    this.setState({ exporting: false });
  }
}
